module.exports = __webpack_public_path__ + "static/img/videoMask.c0bdc92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/videoMask.png
// module id = w657
// module chunks = 1